import React, { useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PuntReturnPlaySelection } from "./PuntReturnPlaySelection";
import { PuntReturnLog } from "./PuntReturnLog";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { PenaltyLog } from "../Components/PenaltyLog";

export const PuntReturnLogger = () => {
  const { puntReturnPlayers } = useDepthChart();
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  return (
    <Paper elevation={3} sx={{ p: 1, margin: "0 auto" }}>
      <Box>
        {/* Play Selection */}
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PuntReturnPlaySelection />
          </AccordionDetails>
        </Accordion>

        {/* Punt Return Log */}
        <Accordion
          expanded={expandedAccordion === "run-log"}
          onChange={handleAccordionChange("run-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="run-log-content"
            id="run-log-header"
          >
            <Typography>Return Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PuntReturnLog />
          </AccordionDetails>
        </Accordion>

        {/* Penalty Log */}
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="penalty-log-content"
            id="penalty-log-header"
          >
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PenaltyLog players={puntReturnPlayers} />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};
